import { render, staticRenderFns } from "./update-topic.vue?vue&type=template&id=43a80bed&scoped=true&lang=html&"
import script from "./update-topic.vue?vue&type=script&lang=js&"
export * from "./update-topic.vue?vue&type=script&lang=js&"
import style0 from "./update-topic.vue?vue&type=style&index=0&id=43a80bed&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a80bed",
  null
  
)

export default component.exports